export { SIMPLE_SEGMENT_MAP, simpleSegment } from './segment';
export { isSegmentEligibleForOffer } from './eligibility';
export type {
  StrapiEntity,
  PopulatedRelation,
  DefaultOfferAttributes,
} from './mdc';
export {
  extractMdcFromRelation,
  isPopulatedRelation,
  parseMdcCodeFromSegment,
} from './mdc';
export {
  ensureMediaRelation,
  createDefaultMedia,
  createDefaultMediaAttributes,
  createDefaultMediaFormat,
} from './media';
export { normalizeOfferPageData } from './normalize';
